<template>
  <shl-result-empty v-if="is_empty"/>
  <shl-result v-else :data="data"/>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex';
  import ShlResultEmpty from "../components/shl-result-empty";
  import ShlResult from "../components/shl-result";

  const {mapGetters} = createNamespacedHelpers('feniche_response_tab_test');

  export default {
    name: "feniche-response-tab-test",
    components: {
      ShlResultEmpty,
      ShlResult,
    },
    computed: {
      ...mapGetters(['data']),
      is_empty () {
        return this.data.reports[0].report.length === 0;
      }
    }
  }
</script>